export default function ({ store }) {
  store.dispatch('multiSelect/clearState');
  store.dispatch('multiSelect/clearTotals');
}
